/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wise_Shy_Jay_DashInputs */

const en_wise_shy_jay_dash = /** @type {(inputs: Wise_Shy_Jay_DashInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Multi-label`)
};

const de_wise_shy_jay_dash = /** @type {(inputs: Wise_Shy_Jay_DashInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Multi-Label`)
};

/**
* | output |
* | --- |
* | "Multi-label" |
*
* @param {Wise_Shy_Jay_DashInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const wise_shy_jay_dash = /** @type {((inputs?: Wise_Shy_Jay_DashInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wise_Shy_Jay_DashInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_wise_shy_jay_dash(inputs)
	return de_wise_shy_jay_dash(inputs)
});